<template>
  <div class="head">
    <div class="logo">
      <img
        v-if="this.$store.state.currentLang === 'zh'"
        :src="this.$path + '/assets/images/logo-zh.png'"
        :alt="$t('langs.aolei')"
      />
      <img
        v-if="this.$store.state.currentLang === 'en'"
        :src="this.$path + '/assets/images/logo-en.png'"
        :alt="$t('langs.aolei')"
      />
    </div>
    <div class="menu">
      <span :class="selected == '/homepower' ? 'choice' : ''">
        <router-link to="/homepower">{{ $t("langs.homepower") }}</router-link>
      </span>
      <span :class="selected == '/centerpower' ? 'choice' : ''">
        <router-link to="/centerpower">
          {{ $t("langs.centerpower") }}
        </router-link>
      </span>
      <span :class="selected == '/outdoorpower' ? 'choice' : ''">
        <router-link to="/outdoorpower">
          {{ $t("langs.outdoorpower") }}
        </router-link>
      </span>
      <span :class="selected == '/centerbms' ? 'choice' : ''">
        <router-link to="/centerbms">{{ $t("langs.centerbms") }}</router-link>
      </span>
      <span :class="selected == '/centermotorcycle' ? 'choice' : ''">
        <router-link to="/centermotorcycle">{{
          $t("langs.centermotorcycle")
        }}</router-link>
      </span>
      <span :class="selected == '/centercloud' ? 'choice' : ''">
        <router-link to="/centercloud">
          {{ $t("langs.centercloud") }}
        </router-link>
      </span>
      <span :class="selected == '/centerwifi' ? 'choice' : ''">
        <router-link to="/centerwifi">{{ $t("langs.centerwifi") }}</router-link>
      </span>
      <span :class="selected == '/aboutus' ? 'choice' : ''">
        <router-link to="/aboutus">{{ $t("langs.aboutus") }}</router-link>
      </span>
      <el-dropdown>
        <span class="el-dropdown-link">
          {{ languageText }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            @click.native="changeLangauge('zh')"
            :class="currentLanguage == 'zh' ? 'language_selectd' : ''"
          >
            <img
              :src="this.$path + '/assets/images/lang-icons/China.jpeg'"
              class="lang_icon"
            />
            {{ $t("langs.languages.china") }}
          </el-dropdown-item>
          <el-dropdown-item
            @click.native="changeLangauge('en')"
            :class="currentLanguage == 'en' ? 'language_selectd' : ''"
          >
            <img
              :src="this.$path + '/assets/images/lang-icons/England.jpg'"
              class="lang_icon"
            />
            {{ $t("langs.languages.england") }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  name: "Head",
  data() {
    return {
      currentLanguage: "zh",
      languageText: "中文",
      selected: this.$route.path || "/homepower",
    };
  },
  methods: {
    /**
     * 切换语言
     */
    changeLangauge(lang) {
      this.$i18n.locale = lang;
      // 将新语言保存到全局状态管理
      this.currentLanguage = lang;
      localStorage.setItem("lang", lang);
      this.$store.dispatch("update_current_lang", lang);
      this.getCurrentLanguageText(lang);
      let router_obj = this.$router.currentRoute;
      //处理语言切换时 网站标题显示问题
      if (router_obj.path) {
        let path = router_obj.path.replace("/", "");
        document.title = `${this.$t("langs." + path)} | ${this.$t("langs.sitetitle")}`;
      } else {
        document.title = this.$t("langs.sitetitle");
      }
    },

    getCurrentLanguageText(lang) {
      switch (lang) {
        case "zh": {
          this.languageText = this.$t("langs.languages.china");
          break;
        }
        case "en": {
          this.languageText = this.$t("langs.languages.england");
          break;
        }
        case "de": {
          this.languageText = this.$t("langs.languages.germany");
          break;
        }
        case "fa": {
          this.languageText = this.$t("langs.languages.france");
          break;
        }
        case "it": {
          this.languageText = this.$t("langs.languages.italy");
          break;
        }
        default: {
          this.languageText = this.$t("langs.languages.china");
        }
      }
    },
  },
  mounted: function () {
    this.currentLanguage = this.$store.state.currentLang;
    this.getCurrentLanguageText(this.currentLanguage);
  },
};
</script>

<style scoped>
@import "../../assets/css/common.css";

.head {
  height: 96px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  background-color: rgba(255, 255, 255, 1);
  padding: 0px 50px;
}

.logo {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: auto;
  margin-right: 15px;
  flex: 0;
}

.logo img {
  width: 154px;
  height: 54px;
}

.menu {
  text-align: right;
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
  width: auto;
  height: 54px;
  line-height: 54px;
  flex: 1;
}

.menu span {
  width: auto;
  padding: 0px 15px;
  cursor: pointer;
}

.choice {
  border-bottom: 3px solid #00d265;
  padding-bottom: 5px !important;
  color: #00d265;
}

.lang_icon {
  width: 32px;
  height: 32px;
  vertical-align: middle;
}

.language_selectd {
  border-bottom: 3px solid #00d265;
  padding-bottom: 5px !important;
  color: #00d265;
}
</style>



// WEBPACK FOOTER //
// src/components/head/head.vue